import type { Brand } from 'types/brands'

import { getBrandTranslationKeys } from './getBrandTranslationKeys'

export const mapLabelKeysToBrands = (brands: Brand[]): Brand[] =>
	brands.map((brand) => ({
		...brand,
		labelKey: getBrandTranslationKeys(brand.id).labelKey,
	}))
